/**
 * Clamps a numerical value between a and b. If a > b, then a and b are swapped.
 * @param value Value to clamp
 * @param a Min value range
 * @param b Max value range
 * @returns  a if value is less than, or b if value is greater than, otherwise returns value.
 */
export function clamp(value: number, a: number, b: number): number {
  if (a > b) {
    const temp = b;
    b = a;
    a = temp;
  }
  if (value < a) {
    return a;
  } else if (value > b) {
    return b;
  }
  return value;
}
